import { LoadingSpinner } from '@discngine/moosa-shared-components';
import { Layout } from 'antd';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import DatasetSelector from '../pages/DatasetSelector/DatasetSelector';
import MultiDimensionsAnalysis from '../pages/MultiDimensionsAnalysis/MultiDimensionsAnalysis';

import Header from './Header';

import './Main.less';

const Moosa3dLazy = React.lazy(() => import('../pages/Viewer3d/Moosa3d'));
const MoosaKanbanLazy = React.lazy(() => import('../pages/KanbanBoard/KanbanBoard'));

const Main: React.FC = () => {
  return (
    <Layout id="mainContainer">
      <Layout.Header className="af-header">
        <Header />
      </Layout.Header>
      <Layout.Content>
        <div id="mainContent">
          <React.Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route element={<MultiDimensionsAnalysis />} path="/data/:id" />
              <Route element={<Moosa3dLazy />} path="/moosa-3d" />

              <Route element={<MoosaKanbanLazy />} path="/kanban" />
              <Route element={<DatasetSelector />} path="/" />
            </Routes>
          </React.Suspense>
        </div>
      </Layout.Content>
    </Layout>
  );
};

export default Main;
